// import React from 'react'
// import {Switch, Route, Redirect} from 'react-router-dom'
import Login from "../pages/login/Login";
import Pathology from "../pages/Pathology/Pathology";

import {
  ACTIONS,
  AuthRoutes,
  NonAuthRoutes,
  USERTYPES,
} from "../constants/Constants";
import AdminUserList from "../pages/AdminUser/AdminUserList";
import Modality from "../pages/Masters/Modality/Modality";
import ErrorStudy from "../pages/ErrorStudy/ErrorStudy";
// import AuditLog from '../pages/AuditLog/AuditLog';
import HospitalsList from "../pages/Hospital/HospitalsList";
import UserView from "../pages/User/UserView";
import ProviderList from "../pages/Provider/ProviderList";
import ClientList from "../pages/Client/ClientList";
import AnnotationList from "../pages/annotation/AnnotationList";
import AddAnnotation from "../pages/annotation/AddAnnotation";
import ViewAnnotation from "../pages/annotation/ViewAnnotation";
import SupervisorList from "../pages/Supervisor/SupervisorList";
import FirmAdminUserList from "../pages/AdminUser/FirmAdminUserList";
import FirmDoctorList from "../pages/Firm/FirmDoctor/FirmDoctorList";
import FirmTechnicianList from "../pages/Firm/FirmTechnician/FirmTechnicianList";
import RadiologistList from "../pages/Radiologist/RadiologistList";
import StudyList from "../pages/StudyList/StudyList";
import HeaderTemplates from "../pages/Templates/HeaderTemplates";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import FirmState from "../context/firms/FirmState";
import HPState from "../context/hanging-protocol/HPState";
import StudylistState from "../context/studylist/StudylistState";
import Viewer from "../pages/StudyViewer/Viewer";
import StudyviewerState from "../context/studyviewer/StudyViewerState";
import StudyReportState from "../context/studyreport/StudyReportState";
import ReportPanel from "../pages/Report/ReportPanel";
import ThumbnailState from "../context/studyviewer/ThumbnailState";
import ViewportState from "../context/studyviewer/ViewportState";
import AnnotationState from "../context/annotation/AnnotationState";
import UploadStudy from "../pages/StudyList/components/UploadStudy/UploadStudy";
// import ShareStudyState from '../context/ShareStudy/ShareStudyState';
import ShareStudyState from "../context/sharestudy/ShareStudyState";
import ViewProvider from "../pages/Provider/ViewProvider";
import ErrorCodeList from "../pages/Masters/ErrorCode/ErrorCodeList";
import MyAddUpdateUser from "../pages/User/MyAddUpdateUser";
import Firm from "../pages/Firm/Firm";
import AddReportTemplate from "../pages/ReportTemplates/AddReportTemplates/AddReportTemplate";
import AddStyle from "../pages/MyStyles/AddStyle/AddStyle";
import HeaderTemplate from "../pages/Masters/HeaderTemplate/HeaderTemplate";
import ACCOUNTANDSETTINGS from "../pages/AccountAndSettings/AccountAndSettings";
import Analytics from "../pages/Analytics/Analytics";
import { SharedReport } from "../pages/StudyList/components/Actions/SendReportEmail";
import { createBrowserRouter } from "react-router-dom";
import IssuesAndTroubleshooting from "../pages/IssuesAndTroubleshooting/IssuesAndTroubleshooting";
import About from "../pages/About/About";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import QRCodeScanReport from "../pages/StudyList/components/QRCodeScanReport";
import ForgotPassword from "../pages/login/ForgotPassword";
import Otp from "../pages/login/Otp";
import ResetPassword from "../pages/login/ResetPassword";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { isMobile } from "react-device-detect";
import AdvanceViewer from "../pages/StudyViewer/AdvanceViewer";
import Billing from "../pages/Billing/Billing";
import IssuesTroubleShooting from "../pages/IssuesAndTroubleshooting/IssuesTroubleShooting";
import ReportTemplateListv2 from "../pages/ReportTemplates/ReportTemplateListv2";
import MyStyles from "../pages/MyStyles/MyStyles";
import ProgressBarState from "../context/progressbar/ProgressBarState";
import Ping from "../components/Ping/Ping";
import SharedStudyViewer from "../pages/SharedViewer/SharedStudyViewer";
import TypistList from "../pages/Firm/Typist/TypistList";
import MobileViewerState from "../context/studyviewer/MobileViewerState";
import MobileMoreOption from "../pages/MobileMoreOption/MobileMoreOption";
import NotAuthorized from "../components/NotAuthorized";
import BillingDownloadDataForm from "../pages/Billing/BillingDownloadDataForm";
import OpenContextStudyList from "../pages/StudyList/OpenContextStudyList";
import SubModality from "../pages/Masters/SubModality/SubModality";
import PacsQueue from "../pages/PacsQueue/PacsQueue";
import DownloadTrigger from "../pages/DownloadTrigger/DownloadTrigger";
import UserDataDump from "../pages/UserDataDump/UserDataDump";
import { ThemeProvider } from "@fluentui/react";
import { lightTheme } from "../constants/Themes";
import TwoFAOtp from "../pages/login/TwoFAOtp";
import HPFormManager from "../pages/HangingProtocol/HPFormManager";
import HangingProtocolList from "../pages/HangingProtocol/HangingProtocolList";
import HpV2GroupList from "../pages/HangingProtocolV2/HpV2GroupList";
import HpV2GroupForm from "../pages/HangingProtocolV2/HpV2GroupForm";
import HpV2ProtocolForm from "../pages/HangingProtocolV2/HpV2ProtocolForm";

import AdvLicense from "../pages/AdvLicence/AdvLicence";
import AiDraftModelStats from "../pages/AiDraftModelStats/AiDraftModelStats";
import GizmoWidget from "../pages/Gizmo/GizmoWigdet";
import GizmoViewer from "../pages/Gizmo/GizmoViewer";
import GizmoWebWidget from "../pages/Gizmo/GizmoWebWidget";
import AnalyticsState from "../context/analytics/AnalyticsState";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AddTemplate from "../pages/MyStyles/AddTemplate/AddTemplate";
import MyTemplates from "../pages/MyTemplate/MyTemplate";

import BlitzSessionState from "../context/blitzsession/BlitzSessionState";
import BlitzSession from "../pages/StudyList/components/BlitzSession/BlitzSession";
import RefreshAgentList from "../pages/AdminUser/RefreshAgentList";
import AgenticLogDownload from "../pages/AdminUser/AgenticLogDownload";
import AIRequests from "../pages/AIRequest/AIRequests";
import GatewayDashboard from "../pages/GatewayDashboard/GatewayDashboard";
import Firm2FirmDashboard from "../pages/Firm2Firm/Firm2FirmDashboard";
import AINodesConfig from "../pages/Masters/AINodesConfig/AINodesConfig";
import ExternalFirmConfig from "../pages/Masters/ExternalFirmConfig/ExternalFirmConfig";

import NewReportWidget from "../pages/NewReportWidget/NewReportWidget";
import ReportWidgetLogin from "../pages/NewReportWidget/ReportWidgetLogin";
import AgenticReportingState from "../context/agentic-reporting/AgenticReportingState";
import ReturnReasonCategoryManagement from "../pages/Masters/ReturnReasonCategory/ReturnReasonCategoryManagement";
import { getEnv } from '../helpers/EnvHelper';
import RouteErrorPage from "../components/RouteErrorPage/RouteErrorPage";



const mobileStyles = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const desktopStyles = {
  height: "100%",
};

const queryClient = new QueryClient();

export const RouterConfig = createBrowserRouter([
  {
  // Pathless parent so every route (and unmatched URLs) gets the friendly error page
  // instead of React Router's developer screen.
  errorElement: <RouteErrorPage />,
  children: [
  {
    path: NonAuthRoutes.ROOT,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <GoogleOAuthProvider clientId={getEnv("REACT_APP_GOOGLE_CLIENT_ID")}>
          <Login />
        </GoogleOAuthProvider>
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.LOGIN,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <GoogleOAuthProvider clientId={getEnv("REACT_APP_GOOGLE_CLIENT_ID")}>
          <Login />
        </GoogleOAuthProvider>
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.FORGOTPASSWORD,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <ForgotPassword />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.ENTEROTP,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <Otp />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.RESETPASSWORD,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <ResetPassword />
      </ThemeProvider>
    ),
  },
  {
        path: NonAuthRoutes.NEWREPORTWIDGET,
        element: (
          <ReportWidgetLogin />
        ),
  },
  {
    path: NonAuthRoutes.GIZMOWIDGET,
    element: (
      // <ThemeProvider
      //   style={isMobile ? mobileStyles : desktopStyles}
      //   applyTo="body"
      //   theme={lightTheme}
      //   className={`app-root light`}
      // >
        <GizmoWidget />
      // </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.GIZMOVIEWER,
    element: (
      // <ThemeProvider
      //   style={isMobile ? mobileStyles : desktopStyles}
      //   applyTo="body"
      //   theme={lightTheme}
      //   className={`app-root light`}
      // >
        <GizmoViewer />
      // </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.GIZMOWEBWIDGET,
    element: (
      // <ThemeProvider
      //   style={isMobile ? mobileStyles : desktopStyles}
      //   applyTo="body"
      //   theme={lightTheme}
      //   className={`app-root light`}
      // >
        <GizmoWebWidget />
      // </ThemeProvider>
    ),
  },
  {
        path: AuthRoutes.REPORTINGWIDGET,
        element: (
          <StudyReportState>
            <AgenticReportingState>
              <NewReportWidget />
            </AgenticReportingState>
          </StudyReportState>
        ),
  },
  {
    path: AuthRoutes.PATHOLOGY,
    element: <Pathology />,
  },
  {
    path: AuthRoutes.ERRORCODE,
    element: <ErrorCodeList />,
  },
  {
    path: AuthRoutes.MODALITY,
    element: <Modality />,
  },
  {
    path: AuthRoutes.SUBMODALITY,
    element: <SubModality />,
  },
  {
    path: AuthRoutes.ANNOTATION,
    element: <AnnotationList />,
  },
  {
    path: AuthRoutes.ADDANNOTATION,
    element: <AddAnnotation />,
  },
  {
    path: AuthRoutes.VIEWANNOTATION,
    element: <ViewAnnotation />,
  },
  {
    path: AuthRoutes.ADMINUSERLIST,
    element: <AdminUserList fullLength={true} fullLengthForRow={true}/>,
  },
  {
    path: AuthRoutes.MYADDADMINUSER,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.ADMIN} />
    ),
  },
  {
    path: AuthRoutes.FIRMADMINUSERLIST,
    element: <FirmAdminUserList fullLength={true} fullLengthForRow={true} />,
  },
  {
    path: AuthRoutes.MYADDFIRMADMINUSER,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.FIRMADMIN} />
    ),
  },
  {
    path: AuthRoutes.MYEDITUSER,
    element: <MyAddUpdateUser action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.MYVIEWUSER,
    element: <MyAddUpdateUser action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.PROVIDERVIEW,
    element: <MyAddUpdateUser action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.ERRORSTUDY,
    element: <ErrorStudy />,
  },
  {
    path: AuthRoutes.ISSUESANDTROUBLESHOOTING,
    element: <IssuesTroubleShooting />,
  },
  {
    path: AuthRoutes.FIRMLIST,
    element:
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true ? (
        <HospitalsList />
      ) : (
        <ClientList />
      ),
  },
  {
    path: AuthRoutes.PROJECTLIST,
    element:
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true ? (
        <HospitalsList firmMode="projects"/>
      ) : (
        <ClientList firmMode="projects" />
      ),
  },
  {
    path: AuthRoutes.CLIENTLIST,
    element: <ClientList />,
  },
  {
    path: AuthRoutes.FIRMDETAILS,
    // element: <HospitalDetails />
    element: (
      <FirmState>
        <Firm action={ACTIONS.VIEW} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.FIRMDETAILS,
    element: (
      <FirmState>
        <Firm action={ACTIONS.VIEW} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.PROJECTDETAILS,
    element: (
      <FirmState>
        <Firm action={ACTIONS.VIEW}
              firmMode="projects" />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.USERVIEW,
    element: <UserView />,
  },
  {
    path: AuthRoutes.EDITHOSPITAL,
    element: (
      <FirmState>
        <Firm action={ACTIONS.EDIT} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.EDITPROJECT,
    element: (
      <FirmState>
        <Firm action={ACTIONS.EDIT} 
              firmMode="projects"/>
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDPROJECT,
    element: (
      <FirmState>
        <Firm action={ACTIONS.ADD} firmType={"Hospital"} firmRole={"CLIENT"}  firmMode="projects" />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDHOSPITAL,
    element: (
      <FirmState>
        <Firm action={ACTIONS.ADD} firmType={"Hospital"} firmRole={"CLIENT"} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDTELERADIOLOGYCENTRE,
    element: (
      <FirmState>
        <Firm
          action={ACTIONS.ADD}
          firmType={"Teleradiology Centre"}
          firmRole={"CLIENT"}
        />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDIMAGINGCENTRE,
    element: (
      <FirmState>
        <Firm
          action={ACTIONS.ADD}
          firmType={"Imaging Centre"}
          firmRole={"CLIENT"}
        />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.SUPERVISORLIST,
    element: <SupervisorList fullLength={true} fullLengthForRow={true} />,
  },
  {
    path: AuthRoutes.MYADDSUPERVISOR,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.SUPERVISOR} />
    ),
  },
  {
    path: AuthRoutes.FIRMDOCTORLIST,
    element: <FirmDoctorList fullLength={true} fullLengthForRow={true} />,
  },
  {
    path: AuthRoutes.MYADDFIRMDOCTOR,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.FIRMDOCTOR} />
    ),
  },
  {
    path: AuthRoutes.FIRMTECHNICIANLIST,
    element: <FirmTechnicianList fullLength={true} fullLengthForRow={true}/>,
  },
  {
    path: AuthRoutes.MYADDFIRMTECHNICIAN,
    element: (
      <MyAddUpdateUser
        action={ACTIONS.ADD}
        userType={USERTYPES.FIRMTECHNICIAN}
      />
    ),
  },
  {
    path: AuthRoutes.TYPISTUSERLIST,
    element: <TypistList fullLength={true} fullLengthForRow={true}/>,
  },
  {
    path: AuthRoutes.ADDTYPIST,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.TYPIST} />
    ),
  },
  {
    path: AuthRoutes.RADIOLOGISTLIST,
    element:
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true ? (
        <RadiologistList  fullLength={true} fullLengthForRow={true}/>
      ) : (
        <ProviderList fullLength={true} fullLengthForRow={true} />
      ),
  },
  {
    path: AuthRoutes.MYADDRADIOLOGIST,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.RADIOLOGIST} />
    ),
  },
  {
    path: AuthRoutes.STUDYLIST,
    element: (
      <StudylistState>
        <StudyReportState>
          <AgenticReportingState>
            <ShareStudyState>
              <StudyList />
            </ShareStudyState>
          </AgenticReportingState>
        </StudyReportState>
      </StudylistState>
    ),
  },
  {
    path: AuthRoutes.REFRESHAGENTLIST,
    element: <RefreshAgentList />,
  },
  {
    path: AuthRoutes.DOWNLOADAGENTICEVENT,
    element: <AgenticLogDownload />,
  },
  {
    path: AuthRoutes.ADMINRADIOLOGISTLIST,
    element: <RadiologistList />,
  },
  {
    path: AuthRoutes.HEADERTEMPLATE,
    element: <HeaderTemplate state={{ action: ACTIONS.ADD }} />,
  },
  {
    path: AuthRoutes.EDITHEADERTEMPLATE,
    element: <HeaderTemplate state={{ action: ACTIONS.EDIT }} />,
  },
  {
    path: AuthRoutes.CHANGEPWD,
    element: <ChangePassword />,
  },
  {
    path: AuthRoutes.FORCECHANGEPWD,
    element: <ChangePassword />,
  },
  {
    path: AuthRoutes.UPLOADSTUDY,
    element: (
      <StudylistState>
        <ProgressBarState>
          <UploadStudy />
        </ProgressBarState>
      </StudylistState>
    ),
  },
  // ,
  // {
  //     path: AuthRoutes.STUDYVIEWER + "/:patientID",
  //     element: <StudyviewerState><ThumbnailState><ViewportState><Viewer/></ViewportState></ThumbnailState></StudyviewerState>
  // }
  {
    path: AuthRoutes.STUDYVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AgenticReportingState>
                <AnnotationState>
                  <ShareStudyState>
                    <MobileViewerState>
                      <Viewer priors={false} />
                    </MobileViewerState>
                  </ShareStudyState>
                </AnnotationState>
              </AgenticReportingState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.BLITZREPORTING,
    element: (
      <StudylistState>
        <StudyReportState>
          <AgenticReportingState>
            <BlitzSessionState>
              <BlitzSession />
            </BlitzSessionState>
          </AgenticReportingState>
        </StudyReportState>
      </StudylistState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.PRIORSTUDYVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AgenticReportingState>
                <AnnotationState>
                  <ShareStudyState>
                    <MobileViewerState>
                      <Viewer priors={true} />
                    </MobileViewerState>
                  </ShareStudyState>
                </AnnotationState>
              </AgenticReportingState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.NONXRAYADVANCEVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AgenticReportingState>
                <AnnotationState>
                  <ShareStudyState>
                    <MobileViewerState>
                      <AdvanceViewer priors={false} />
                    </MobileViewerState>
                  </ShareStudyState>
                </AnnotationState>
              </AgenticReportingState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.REPORTTEMPLATES,
    element: <ReportTemplateListv2 />,
  },
  {
    path: AuthRoutes.MY_STYLES,
    element: (
      <QueryClientProvider client={queryClient}>
        <MyStyles />
      </QueryClientProvider>
    ),
  },
  // {
  //   path: "report/list/template/new/:tabId",
  //   element: <ReportTemplateListv2 />,
  // },


  {
    path: AuthRoutes.AGENTIC_TEMPLATE,
    element: (
      <QueryClientProvider client={queryClient}>
        <MyTemplates />
      </QueryClientProvider>
    )
  },
  {
    path: AuthRoutes.ADD_AGENTIC_TEMPLATE,
    element: <AddTemplate action={ACTIONS.ADD} />,
  },
  {
    path: AuthRoutes.EDIT_AGENTIC_TEMPLATE,
    element: <AddTemplate action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.AI_NODE_CONFIG,
    element: (
      <QueryClientProvider client={queryClient}>
        <AINodesConfig />
      </QueryClientProvider>
    )
  },
  {
    path: AuthRoutes.EXTERNAL_FIRM_CONFIG,
    element: (
      <QueryClientProvider client={queryClient}>
        <ExternalFirmConfig />
      </QueryClientProvider>
    )
  },
  {
    path: AuthRoutes.RETURN_REASON_CATEGORY_MANAGEMENT,
    element: (
      <QueryClientProvider client={queryClient}>
        <ReturnReasonCategoryManagement />
      </QueryClientProvider>
    )
  },
  {
    path: AuthRoutes.ADDREPORTTEMPLATE,
    element: <AddReportTemplate action={ACTIONS.ADD} />,
  },
  {
    path: AuthRoutes.EDITREPORTTEMPLATE,
    element: <AddReportTemplate action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.EDIT_STYLE,
    element: (
      <QueryClientProvider client={queryClient}>
        <AddStyle action={ACTIONS.EDIT} />
      </QueryClientProvider>
    ),
  },
  {
    path: AuthRoutes.ADD_STYLE,
    element: (
      <QueryClientProvider client={queryClient}>
        <AddStyle action={ACTIONS.ADD} />
      </QueryClientProvider>
    ),
  },
  {
    path: AuthRoutes.ACCOUNTANDSETTINGS,
    element: <ACCOUNTANDSETTINGS />,
  },
  {
    path: AuthRoutes.ANALYTICS,
    element: (
      <AnalyticsState>
        <Analytics />
      </AnalyticsState>),
  },
  {
    path: AuthRoutes.SHOW_SHARED_REPORT,
    element: <SharedReport />,
  },
  {
    path: AuthRoutes.ABOUT,
    element: <About />,
  },
  {
    path: NonAuthRoutes.VIEWPDF,
    element: <QRCodeScanReport />,
  },
  {
    path: AuthRoutes.BILLING,
    element: <Billing />,
  },
  {
    path: AuthRoutes.BILLING_DATA_DOWNLOAD_FORM,
    element: <BillingDownloadDataForm />,
  },
  {
    path: AuthRoutes.PING,
    element: <Ping />,
  },
  {
    path: AuthRoutes.PRIVACY_POLICY,
    element: <PrivacyPolicy />,
  },
  {
    path: AuthRoutes.SHAREDVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AgenticReportingState>
                <AnnotationState>
                  <ShareStudyState>
                    <MobileViewerState>
                      <SharedStudyViewer />
                    </MobileViewerState>
                  </ShareStudyState>
                </AnnotationState>
              </AgenticReportingState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.MOBILEMORE,
    element: <MobileMoreOption />,
  },
  {
    path: AuthRoutes.PACSQUEUELIST,
    element: <PacsQueue />,
  },
  {
    path: AuthRoutes.AIREQUESTLIST,
    element: <AIRequests />,
  },
  {
    path: AuthRoutes.GATEWAY_DASHBOARD,
    element: <GatewayDashboard />,
  },
  {
    path: AuthRoutes.FIRM2FIRM_DASHBOARD,
    element: <Firm2FirmDashboard />,
  },
  {
    path: AuthRoutes.ADVLICENSE,
    element: <AdvLicense />,
  },
  {
    path: AuthRoutes.AIDRAFTMODELSTATS,
    element: <AiDraftModelStats />,
  },
  {
    path: AuthRoutes.NOT_ALLOWED,
    element: <NotAuthorized />,
  },
  {
    path: NonAuthRoutes.CONTEXTSWITCHSTUDYLIST,
    element: (
      <StudylistState>
        <StudyReportState>
          <AgenticReportingState>
            <ShareStudyState>
              <StudyList />
            </ShareStudyState>
          </AgenticReportingState>
        </StudyReportState>
      </StudylistState>
    ),
  },
  {
    path: NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER,
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AgenticReportingState>
                <AnnotationState>
                  <ShareStudyState>
                    <MobileViewerState>
                      <Viewer priors={false} />
                    </MobileViewerState>
                  </ShareStudyState>
                </AnnotationState>
              </AgenticReportingState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
  },
  {
    path: AuthRoutes.DOWNLOADTRIGGER,
    element: <DownloadTrigger />,
  },
  {
    path: AuthRoutes.USER_DATA_DUMP,
    element: <UserDataDump />,
  },
  {
    path: NonAuthRoutes.TWOFACTORAUTHENTICATION,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
      <TwoFAOtp />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: AuthRoutes.HANGINGPROTOCOLLIST,
    element: <HangingProtocolList />,
  },
  {
    path: AuthRoutes.HANGINGPROTOCOLV2,
    element: <HpV2GroupList />,
  },
  {
    path: AuthRoutes.HPV2_ADDGROUP,
    element: <HpV2GroupForm action={ACTIONS.ADD} />,
  },
  {
    path: AuthRoutes.HPV2_EDITGROUP,
    element: <HpV2GroupForm action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.HPV2_VIEWGROUP,
    element: <HpV2GroupForm action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.HPV2_ADDPROTOCOL,
    element: <HpV2ProtocolForm action={ACTIONS.ADD} />,
  },
  {
    path: AuthRoutes.HPV2_EDITPROTOCOL,
    element: <HpV2ProtocolForm action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.HPV2_VIEWPROTOCOL,
    element: <HpV2ProtocolForm action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.ADDHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.ADD} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.EDITHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.EDIT} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.VIEWHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.VIEW} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.STYLES,
    element: (
      <QueryClientProvider client={queryClient}>
        <MyStyles />
      </QueryClientProvider>
    ),
  }
  ],
  },
], {
  future: {
    v7_startTransition: true,
  },
});
